import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface IRecallParams {
    id: string;
    context: string;
}

@Injectable({
    providedIn: 'root',
})
export class RecallService {
    @Inject(DOCUMENT) private dom: Document = inject(DOCUMENT);
    private route: ActivatedRoute = inject(ActivatedRoute);
    private router: Router = inject(Router);

    private readonly BASE_RECALL_URL: string = 'https://www.bouyguestelecom.fr/rappelez-moi';
    private readonly DEFAULT_RECALL_PARAM: IRecallParams = {
        id: 'tlvctcmobile1',
        context: 'ACQUISITION-GP',
    };

    public initRouteHandler(): Observable<void> {
        return this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => {
                this.setMetaRecall(this.getRecallParam(this.route.firstChild));
            }),
        );
    }

    public setMetaRecall(recallParam: IRecallParams): void {
        this.setMetaUrl(recallParam.id);
        this.setMetaContext(recallParam.context);
    }

    public setMetaUrl(id: string): void {
        const url = id ? this.getRecallUrl(id) : '';
        const recall = this.dom.head.querySelector('meta[name=recall]');
        recall.setAttribute('content', url);
    }

    private getRecallUrl(recallParam: string): string {
        return `${this.BASE_RECALL_URL}?callback=${recallParam}`;
    }
    private getRecallParam(activatedRoute: ActivatedRoute | null): IRecallParams {
        while (activatedRoute) {
            if (activatedRoute.firstChild) {
                activatedRoute = activatedRoute.firstChild;
            } else if (activatedRoute.snapshot.data?.recallId) {
                const queryParams = activatedRoute.snapshot.queryParamMap;
                if (
                    queryParams.get('focus')?.includes('se_medium') ||
                    queryParams.get('gamme')?.includes('se_medium') ||
                    activatedRoute.snapshot.url.some((url) => url.path.includes('bboxbandyou'))
                ) {
                    return {
                        id: undefined,
                        context: activatedRoute.snapshot.data.recallContext,
                    };
                }

                if (queryParams.get('focus')) {
                    return {
                        id: activatedRoute.snapshot.data.recallId,
                        context: activatedRoute.snapshot.data.recallContext,
                    };
                }
                return {
                    id: activatedRoute.snapshot.data.recallId,
                    context: activatedRoute.snapshot.data.recallContext,
                };
            } else {
                return this.DEFAULT_RECALL_PARAM;
            }
        }
    }

    private setMetaContext(context: string): void {
        const recall = this.dom.head.querySelector('meta[name=recall-context]');
        recall.setAttribute('content', context);
    }
}
